import React from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

import "../../styles/alert.css";

export const AppAlert = ({caption, message, accept, abort, handleAbort, handleAccept, handleClose}) => {
    return (
        <div className="alert-bg">
            <div className="alert-box">
                <div className="close-bx">
                    <div className="cap-box">{caption}</div>
                    <button className={classNames("cls-btn")} onClick={handleClose}>
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                </div>
               
                <div className="mesg-sec">{message}</div>
                <div className="act-button-box">
                    {accept && 
                        <button 
                            className="act-button"
                            onClick={handleAccept}
                        >
                            {accept}
                        </button>
                    }
                    {abort && 
                        <button 
                            className="act-button"
                            onClick={handleAbort}
                        >
                            {abort}
                        </button>}
                </div>
            </div>
        </div>
    )
}